import React, { useState } from "react";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { useParams } from "react-router-dom";
import Sidebar from "../Sidebar/Sidebar";
import "./PharmacyBranchPasswordReset.css";
import { cloudApi } from "../../api";

const PharmacyBranchPasswordReset = () => {
  const { branchId } = useParams();
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSuccess("");

    if (newPassword !== confirmPassword) {
      setError("❌ Passwords do not match.");
      return;
    }

    try {
      setLoading(true);
      const response = await cloudApi.put(`/users/pharmacy/branch/${branchId}/password`, {
        new_password: newPassword,
      });

      setSuccess(response.data.message || "✅ Password updated successfully.");
      setNewPassword("");
      setConfirmPassword("");
    } catch (err) {
      console.error("Password update failed:", err);
      const msg = err?.response?.data?.detail || "❌ Password update failed.";
      setError(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="pbpr-page-container">
      <Sidebar />
      <div className="pbpr-content">
        <div className="pbpr-form-container">
          <h3>Reset Branch Password</h3>
          <form onSubmit={handleSubmit}>
            {/* New Password */}
            <div className="pbpr-password-wrapper">
              <input
                type={showNewPassword ? "text" : "password"}
                placeholder="New Password"
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
                required
              />
              <span
                className="pbpr-password-toggle-icon"
                onClick={() => setShowNewPassword((prev) => !prev)}
              >
                {showNewPassword ? <FaEyeSlash /> : <FaEye />}
              </span>
            </div>

            {/* Confirm Password */}
            <div className="pbpr-password-wrapper">
              <input
                type={showConfirmPassword ? "text" : "password"}
                placeholder="Confirm New Password"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                required
              />
              <span
                className="pbpr-password-toggle-icon"
                onClick={() => setShowConfirmPassword((prev) => !prev)}
              >
                {showConfirmPassword ? <FaEyeSlash /> : <FaEye />}
              </span>
            </div>

            <button type="submit" disabled={loading}>
              {loading ? "Updating..." : "Update Password"}
            </button>
          </form>

          {error && <div className="pbpr-error-message">{error}</div>}
          {success && <div className="pbpr-success-message">{success}</div>}
        </div>
      </div>
    </div>
  );
};

export default PharmacyBranchPasswordReset;
